<template>
    <v-dialog v-model="dialog" persistent fullscreen>
        <v-card tile class="pa-0">
            <slot></slot>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: "fullScreenDialog",
    props: ['parameter', 'value'],
    data: () => ({
        dialog: false,
    }),
    computed: {
        routeKey(){ return this.$route.query[this.parameter] },
    },
    created(){
        if ( this.routeKey === this.value ) {
            window.history.back();
        }
    },
    methods: {
        openOrClose(to, from){
            if ( to === this.value && !from ) {
                this.dialog = true;
            } else if ( from === this.value && !to ) {
                this.dialog = false;
            }
        },
    },
    watch: {
        routeKey(to, from){
            this.openOrClose(to, from);
        },
        value(to, from){
            if ( to && !from && this.routeKey === to ) {
                this.dialog = true;
            }

        }
    }
}
</script>

<style scoped>

</style>